import { render, staticRenderFns } from "./BranchMembers.vue?vue&type=template&id=132a7498&scoped=true"
import script from "./BranchMembers.vue?vue&type=script&lang=js"
export * from "./BranchMembers.vue?vue&type=script&lang=js"
import style0 from "./BranchMembers.vue?vue&type=style&index=0&id=132a7498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132a7498",
  null
  
)

export default component.exports